module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/OatmealPro2-Bold.4231042f.woff2";